import { render, staticRenderFns } from "./VirtualWalletAddOnListing.vue?vue&type=template&id=9f04276e&"
import script from "./VirtualWalletAddOnListing.vue?vue&type=script&lang=js&"
export * from "./VirtualWalletAddOnListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports